"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGoogleMaps;

var _useGoogleMap = _interopRequireDefault(require("@devsontap/dot-react-common/core/maps/useGoogleMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useGoogleMaps(lat, lng, zoom, mapConfig, elementId) {
  return (0, _useGoogleMap.default)("AIzaSyC14vZJSWjdgO5f6MYfxmjycl6Uy4Lm_tY&libraries=places", lat, lng, zoom, mapConfig, elementId);
}